import React from 'react';
import { Text } from 'ds/components/typography';
import { GreyWrapper, EmptyListText, EmptyListWrapper } from './styled';

interface EmptyList {
  icon: JSX.Element;
  text: string;
  locator?: string;
}


const EmptyList: React.FC<EmptyList> = ({ icon, text, locator }) => (
  <EmptyListWrapper data-auto={locator}>
    {icon}
    <EmptyListText>
      <GreyWrapper>
        <Text>{text}</Text>
      </GreyWrapper>
    </EmptyListText>
  </EmptyListWrapper>
);

export default React.memo(EmptyList);
